/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSchedulePutRequestScheduleInner
 */
export interface MessageSchedulePutRequestScheduleInner {
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequestScheduleInner
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequestScheduleInner
     */
    end?: string;
}

/**
 * Check if a given object implements the MessageSchedulePutRequestScheduleInner interface.
 */
export function instanceOfMessageSchedulePutRequestScheduleInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageSchedulePutRequestScheduleInnerFromJSON(json: any): MessageSchedulePutRequestScheduleInner {
    return MessageSchedulePutRequestScheduleInnerFromJSONTyped(json, false);
}

export function MessageSchedulePutRequestScheduleInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSchedulePutRequestScheduleInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
    };
}

export function MessageSchedulePutRequestScheduleInnerToJSON(value?: MessageSchedulePutRequestScheduleInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'end': value.end,
    };
}

